import React from 'react';
import {
    Modal,
    Input,
    Form,
    Select,
    Checkbox
} from 'antd';

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    nombre: values.nombre,
                    codigoSunat: values.codigoSunat.key,
                    idTipoMovimiento: values.idTipoMovimiento.key,
                    flagCostear: values.flagCostear
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Concepto" : "Modificar Concepto"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Código Sunat">
                                {getFieldDecorator('codigoSunat', {
                                    initialValue: this.props.formValues.codigoSunat ?
                                        { key: this.props.formValues.codigoSunat } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione código sunat"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.conceptos.map(item => (
                                            <Option key={item.codigoSunat} value={item.codigoSunat}>{item.codigoSunat} - {item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Tipo Movimiento">
                                {getFieldDecorator('idTipoMovimiento', {
                                    initialValue: this.props.formValues.idTipoMovimiento ?
                                        { key: this.props.formValues.idTipoMovimiento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione tipo movimiento"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.tiposMovimiento.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Costear">
                                {getFieldDecorator('flagCostear', {
                                    initialValue: this.props.formValues.flagCostear,
                                    valuePropName: 'checked'
                                })(<Checkbox></Checkbox>)}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)